// on product-option-size__text click, fade in the #popup
// $(document).on('click', '.product-option-size__text', function() {
//     $('#popup').fadeIn();
//     }
// );

// $(document).on('click', '.close', function() {
//     $('#popup').fadeOut();
//     }
// );

// on document load
$(document).ready(function() {
  // if the user has scrolled down the page past the #product-main, add the 'super-active' class
  // to the product-sticky-bar

  // on scroll event 
  // if the user has scrolled down the page past the #product-main, add the 'super-active' class
  // to the product-sticky-bar
  // $(document).on('scroll', function() {
  //     const scrollPosition = window.scrollY;
  //     const productMainOffset = document.querySelector('.product-add-to-cart').offsetTop;
  //     const productStickyBar = document.querySelector('.product-sticky-bar');
  //     const productStickyBarHeight = productStickyBar.offsetHeight;
  //     console.log('scroll position',scrollPosition);
  //     console.log('main offset',productMainOffset);
  //     if (scrollPosition > 1000) {
  //         productStickyBar.classList.add('super-active');
  //         // console.log('is super active');
  //     } else {
  //         productStickyBar.classList.remove('super-active');
  //         // console.log('not super active');
  //     }
  // });

  // Check if a session variable 'firstVisit' is set
   if (!sessionStorage.getItem('firstVisit')) {
      // If 'firstVisit' is not set, show the hero banner
      // if .hero-banner exists, then show it
      if (document.querySelector('.hero-banner')) {
          document.querySelector('.hero-banner').style.display = 'flex';
      }

      // Set the session variable to indicate that this is their first visit
      sessionStorage.setItem('firstVisit', 'true');
  }

  // if the url contains the string 'hero', show the .hero-banner
  if (window.location.href.indexOf('hero') !== -1) {
      document.querySelector('.hero-banner').style.display = 'flex';
  }

  console.log('firstVisit:', sessionStorage.getItem('firstVisit'));
  console.log('harc-custom.js loaded');
  console.log('where is first visit');
});




$(document).ready(function() {


  // Destroy any existing slider
  // $('.product-slider_thumb').slick('unslick'); 
  
  // Reinitialize the slider with custom options
  // $('.product-slider_thumb').slick({
  //   infinite: true,
  //   slidesToShow: 4, // Adjust the number of thumbnails shown
  //   slidesToScroll: 1,
  //   // autoplay: true,
  //   // autoplaySpeed: 2000,
  //   arrows: true,
  //   dots: false
  // });




});

$('.back-in-stock-popup .close').click(function() {
  if ($(this).hasClass('refresh')) {
    location.reload();
  }
});



$(document).ready(function () {
  // Check if the Slick Slider is initialized
  if ($('.product-slider').hasClass('slick-initialized')) {
    // Reinitialize or update the slider with arrows
    $('.product-slider').slick('slickSetOption', {
      arrows: true, // Enable arrows
      prevArrow: '<button type="button" class="slick-prev">Previous</button>',
      nextArrow: '<button type="button" class="slick-next">Next</button>'
    }, true); // `true` reinitializes the slider
  } else {
    // Initialize the slider if not already initialized
    $('.product-slider').slick({
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev">Previous</button>',
      nextArrow: '<button type="button" class="slick-next">Next</button>'
    });
  }
});

  // Listen for slide changes
  $('.product-slider').on('afterChange', function (event, slick, currentSlide) {
    // Pause all videos first
    $('.product-slider video').each(function () {
      this.pause();
      this.currentTime = 0; // Optional: Reset to the beginning
    });

    // Find the active slide
    var activeSlide = $(slick.$slides[currentSlide]);

    // Check if it contains a video and play it
    var video = activeSlide.find('video')[0];
    if (video) {
      video.play();
    }
  });

